// typescript
import { Layout } from 'antd';
import { toUpper } from 'lodash';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';
import ErrorBoundary from '../components/ErrorBoundary';
import { UnauthenticatedAppProviders } from '../context';
import { useAuth } from '../context/auth/AuthProvider';
import { useTenant } from '../context/tenant/TenantProvider';
import EmailCodeForm from '../login/EmailCodeForm';
import EmailLoginForm from '../login/EmailLoginForm';
import Footer from './Footer';

const { Content } = Layout;

const ScLayout = styled(Layout)`
  min-height: 100vh;
`;

const UnauthenticatedApp: React.FC = (props) => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const { tenant } = useTenant();
  const location = useLocation();
  const { from } = (location.state as any) || { from: { pathname: '/' } };

  return !isAuthenticated ? (
    <UnauthenticatedAppProviders>
      <ScLayout>
        <Helmet title={`${toUpper(tenant.id)} ${t('DIGITAL_DEALER')}: ${t('AUTH__SIGN_IN')}`} />

        <Content>
          <ErrorBoundary>
            <Routes>
              <Route path="/code" element={<EmailCodeForm />} />
              <Route path="/" element={<EmailLoginForm />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </ErrorBoundary>
        </Content>

        <Footer />
      </ScLayout>
    </UnauthenticatedAppProviders>
  ) : (
    <Navigate to={from} replace />
  );
};

export default UnauthenticatedApp;
